import { render, staticRenderFns } from "./SurgeryContentPage.vue?vue&type=template&id=0935ccb2"
import script from "./SurgeryContentPage.vue?vue&type=script&lang=js"
export * from "./SurgeryContentPage.vue?vue&type=script&lang=js"
import style0 from "./SurgeryContentPage.vue?vue&type=style&index=0&id=0935ccb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports